module.exports = __webpack_public_path__ + "static/media/synthetix.0d30c863.png";